module.exports = __webpack_public_path__ + "static/fish-meat-555d5172daef3d9c3a1a824eb73fd576.svg";